module.exports = __webpack_public_path__ + "static/media/brand-vibes-top.22490ccf.png";